import type React from 'react';

import type { DeepfakeStateNullable } from '@vlabs/api/luna-api/model/DeepfakeStateNullable';

import { useEventDetailsGeneralInfoTranslation } from '../i18n';
import st from './shared.module.sass';

interface DeepfakeRowProps {
  deepfake?: DeepfakeStateNullable;
}

function DeepfakeRow({ deepfake = null }: DeepfakeRowProps): string | React.JSX.Element {
  const { t } = useEventDetailsGeneralInfoTranslation();

  if (deepfake === 0) return t('deepfake_0');
  if (deepfake === 1) return t('deepfake_1');
  return (<span className={st.Null}>{t('deepfake_null')}</span>);
}

export { DeepfakeRow };
